/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import ProveedorEstado from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import FormularioMarcasCV from './controladorVista/formularioMarcasCV';
import TablaMarcasCV from './controladorVista/tablaMarcasCV';
import { estadoIncial, reductor } from './reductorMarcas';

const Marcas: React.FunctionComponent = () => (
    <ProveedorEstado estadoInicial={estadoIncial} reductor={reductor}>
        <TablaMarcasCV />
        <FormularioMarcasCV />
    </ProveedorEstado>
);

export default Marcas;
